//authServices.js

import apiClient from '../api/apiClient';

const authServices = {

  login: async (mobile,password) => {
    try {
      const response = await apiClient.post(`/login/adminLogin`, {
        username: mobile,
        password: password,
      });

      if (response.data.Status === "SUCCESS") {
        localStorage.setItem('authToken', response.data.data);
        
        return {token: response.data};
      }
      else {
      }
    } catch (error) {
      const errorMessage = error.response ? error.response.data.message : "An unknown error occurred";
      console.error("this Login error: ", errorMessage);
      return { errorMsg: errorMessage };
    }
  },


  
  logout: () => {
    localStorage.removeItem('authToken');
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('authToken');  // Returns true if token exists
  },
  
  getToken: () => {
    return localStorage.getItem('authToken');
  },
};

export default authServices;